// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9fa84a24","453":"3a4ae138","455":"99e56a76","977":"70a59ced"}[chunkId] + ".chunk.js";
};